import { createSlice } from '@reduxjs/toolkit'
import {
  getChatLanguageRoom
} from 'redux-thunk/thunk/chat.thunk'

const initialState = {
  chatLanguageRoom: null
}

const chatSlice = createSlice({
  name: 'chat',
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getChatLanguageRoom.fulfilled, (state, action) => {
        return {
          ...state,
          chatLanguageRoom: action.payload
        }
      })
  }
})

export default chatSlice.reducer
